<!-- <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.2.0/css/all.css" integrity="sha384-hWVjflwFxL6sNzntih27bfxkr27PmbbK/iSvJ+a4+0owXq79v+lsFkW54bOGbiDQ" crossorigin="anonymous">
  <link rel="stylesheet" href="./style/style.css"> -->
<template>
  <div class="postit">
    <!-- <h1>即時留言牆</h1> -->
    <div style="padding-top: 20px; padding-bottom: 20px;">
      <b-card-group deck class="abc">
        <mdb-card wide color="#ffebee red lighten-5">
          <mdb-card-body class="text-center" cascade>

            <mdb-card-text style="font-size:25px; text-align: left; line-height:60px;">
              好OA，不投嗎？<br>類似棒球九宮格<br>每個數字後面有一個OA小知識<br>投中3球Bingo連線可得獎品
            </mdb-card-text>

          </mdb-card-body>
        </mdb-card>
        <mdb-card wide color="#e1f5fe light-blue lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px; text-align: center;">
              <br><br>
              拍攝OA微電影，<br>讓讀者在90秒內知道OA是什麼？
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
        <mdb-card wide color="#f9fbe7 lime lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px; text-align: center;">
              <br><br>
              在IG or FB hashtag(#) 'Open Access'，就能參加抽獎
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </b-card-group>
      <b-card-group deck class="abc">
        <mdb-card wide color="rgba(255, 152, 0, 0.3) rgba-orange-light">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px;text-align: center;">
              <br><br>
              整理單位已發表文章（OA）<br>被引數供主管參考（能見度）
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
        <mdb-card wide color="#ede7f6 deep-purple lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px;text-align: center; line-height:200px;">
              教育訓練（有獎徵答）
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
        <mdb-card wide color="#fce4ec pink lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px; text-align: center; ">
              <br>
              成立OA<br>FB粉絲頁宣傳OA概念活動<br>（文字、圖片、影片、抽獎）
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </b-card-group>

      <b-card-group deck class="abc">
        <mdb-card wide color="#e0f2f1 teal lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px; text-align: center;">
              <br>
              「金科玉律」OA知識抽獎活動：<br>答對10個OA相關問題，<br>可獲得3次抽獎機會<br>
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
        <mdb-card wide color="#fff3e0 orange lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px; text-align: center;">
              <br>
              各學院放置一OA符號的集章及OA相關知識，<br>跑完各學院蓋完章者可獲得獎品<br>
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
        <mdb-card wide color="#b2ebf2 cyan lighten-5">
          <mdb-card-body class="text-center" cascade>
            <mdb-card-text style="font-size:25px;text-align: center;">
              <br>
              OA網頁<br>
          OA概念/掠奪概念/白名單/<br>小影片/有獎徵答<br><br>

            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </b-card-group>

    </div>
  </div>
</template>
<script>
import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardImage, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter, mdbCardUp, mdbCardAvatar, mdbCardGroup, mdbBtn, mdbView, mdbMask, mdbIcon } from 'mdbvue';

export default {
  name: 'Postit',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbBtn,
    mdbView,
    mdbMask,
    mdbIcon
  }



};

</script>
<style>

.abc {
  font-family: Microsoft JhengHei;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 25px;
  padding-top: 25px;
}
.postit {
  background-color: rgba(248, 194, 88,0.1);
}

</style>
